import { Modal } from '@/common/ui/Modal'
import type { ProductTextsGenerationState } from '../../model/textsGeneration'
import { TextsGenerationsList, type MarketplaceTextsSelection } from '../Texts/TextsGenerationsList'
import { closeMarketplaceDataPickerModal, MARKETPLACE_DATA_PICKER_MODAL_ID } from './marketplaceDataPickerModalState'

type MarketplaceDataPickerModalProps = {
    textsState: ProductTextsGenerationState
    onSelect: (data: MarketplaceTextsSelection) => void
}

export const MarketplaceDataPickerModal = ({ textsState, onSelect }: MarketplaceDataPickerModalProps) => {
    const handleSelect = (data: MarketplaceTextsSelection) => {
        onSelect(data)
        closeMarketplaceDataPickerModal()
    }

    return (
        <Modal id={MARKETPLACE_DATA_PICKER_MODAL_ID} modalClassName='md:w-4xl max-w-none! max-h-[85vh] overflow-y-auto'>
            <h3 className='mb-4 text-lg font-medium text-white'>Выбор Текстов и SEO</h3>
            <TextsGenerationsList
                state={textsState}
                selectionMode
                onSelect={handleSelect}
                emptyListMessage='Нет генераций текстов. Выберите данные импорта ниже.'
            />
        </Modal>
    )
}
